var _circle, _circle2, _circle3, _circle4, _circle5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 81,
    viewBox: "0 0 83 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 43,
    r: 38,
    fill: "#F0F7F3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 13,
    r: 13,
    fill: "#49E8C2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 43,
    r: 37,
    stroke: "#1F342F",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 43,
    r: 30,
    fill: "white",
    stroke: "#1F342F",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(1 0 0 -1 38.5 43)",
    fill: "#F0F7F3",
    stroke: "#1F342F",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 26,
    width: 2,
    height: 15,
    rx: 1,
    fill: "#1F342F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 12,
    width: 2,
    height: 5,
    rx: 1,
    fill: "#1F342F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 44,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-90 7.5 44)",
    fill: "#1F342F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 44,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-90 64.5 44)",
    fill: "#1F342F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8726,
    y: 21.7891,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-45 15.8726 21.7891)",
    fill: "#1F342F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.1777,
    y: 62.0938,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-45 56.1777 62.0938)",
    fill: "#1F342F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 66.8672,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-25.7635 47.5 66.8672)",
    fill: "#1F342F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(-0.900596 -0.434657 -0.434657 0.900596 29.4745 66.8672)",
    fill: "#1F342F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(0.900596 0.434657 0.434657 -0.900596 47.5 18.5)",
    fill: "#1F342F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4745,
    y: 18.5,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(154.237 29.4745 18.5)",
    fill: "#1F342F"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2867,
    y: 65.625,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-135 17.2867 65.625)",
    fill: "#1F342F"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5919,
    y: 25.3203,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-135 57.5919 25.3203)",
    fill: "#1F342F"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2984,
    y: 55.9141,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-112.75 10.2984 55.9141)",
    fill: "#1F342F"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 62.864,
    y: 33.8672,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-112.75 62.864 33.8672)",
    fill: "#1F342F"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(0.416765 -0.909014 -0.909014 -0.416765 66.2628 56.8281)",
    fill: "#1F342F"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(0.416765 -0.909014 -0.909014 -0.416765 14.045 33.8984)",
    fill: "#1F342F"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3378,
    y: 30,
    width: 2,
    height: 24.0614,
    rx: 1,
    transform: "rotate(60 61.3378 30)",
    fill: "#1F342F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.513662b495ceb3d1bf4e4b389e7b2e88.svg";
export { ForwardRef as ReactComponent };